import { getRootUrl } from '@share-a-cart/shared-utils';

import i18n from 'src/utils/i18n/i18n';

import {
  flattenFaq,
  lookupFaq,
  stillStuckText,
  type FaqEntry,
  type FaqIntro,
  type FaqStillStuck,
} from './faqKnowledge';

function tObject<T>(key: string): T | undefined {
  const value = i18n.t(key, { returnObjects: true });
  return typeof value === 'string' ? undefined : (value as T);
}

export function currentFaqEntries(): FaqEntry[] {
  return flattenFaq(
    {
      intro: tObject<FaqIntro>('faqs.intro'),
      sections: tObject<unknown>('faqs.sections'),
    },
    getRootUrl(),
  );
}

export function currentStillStuck(): string {
  return stillStuckText(tObject<FaqStillStuck>('faqs.still_stuck'), getRootUrl());
}

export function lookupCurrentFaq(query: string): FaqEntry | null {
  return lookupFaq(currentFaqEntries(), query);
}
